import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-data-protection',
  templateUrl: './new-data-protection.component.html',
  styleUrls: ['./new-data-protection.component.scss']
})
export class NewDataProtectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
